// extracted by mini-css-extract-plugin
export default {"modalWaraper":"migrationFormSuccessModal_modalWaraper__+KR2A","mb32":"migrationFormSuccessModal_mb32__hPL7f"};